import React from "react";
import { useState } from "react";
import "./Products.css";
import Water from "./water/Water";
import UploadImage from "./UploadImage";
import { ColdDrinks } from "./cold-drinks/ColdDrinks";

const Products = () => {
  const softDrinks = "softDrinkDivBtn";
  const water = "waterDivBtn";

  const [softDrinksDiv, setSoftDrinksDiv] = useState(true);
  const [waterDiv, setWaterDiv] = useState(false);
  // const [sodaDiv, setSodaDiv] = useState(false);

  const hello = (classname) => {
    if (classname === softDrinks) {
      console.log(classname, "classname");
      setSoftDrinksDiv(true);
      setWaterDiv(false);
    } else if (classname === water) {
      setSoftDrinksDiv(false);
      setWaterDiv(true);
    }
  };

  return (
    <>
      <div className="contentOfProducts">
        <div className="productDiv">
          {/* <div className="allPages"> */}
          <div className="paginationDiv">
            <div
              onClick={() => {
                hello(softDrinks);
              }}
              id={softDrinks}
              className="pages"
            >
              Beverages
            </div>
            <div
              onClick={() => {
                hello(water);
              }}
              id={water}
              className="pages"
            >
              Packaged Drinking Water
            </div>
          </div>
          <br />
          <br />
          <br />
          {/* {sodaDiv && <Soda/>} */}
          {softDrinksDiv && <ColdDrinks />}
    {waterDiv && <Water/>}
        </div>
      </div>
    </>
  );
};

export default Products;
